import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import groupWithWallSwitch from "../../../assets/smarthome/smartSection/groupWithWallSwitch.jpg";
import groupIphoneMockup from "../../../assets/smarthome/smartSection/groupIphoneMockup.png";

import automation1Image from "../../../assets/smarthome/smartSection/Automatisation1.jpg";
import automation2Image from "../../../assets/smarthome/smartSection/Automatisation2.jpg";
import timeIcon from "../../../assets/smarthome/smartSection/icones/time.png";
import openIcon from "../../../assets/smarthome/smartSection/icones/open.png";
import motionIcon from "../../../assets/smarthome/smartSection/icones/motion.png";
import illuminanceIcon from "../../../assets/smarthome/smartSection/icones/illuminance.png";
import lightBlack from "../../../assets/smarthome/smartSection/icones/eclairageBlack.png";
import notificationIcon from "../../../assets/smarthome/smartSection/icones/notification.png";

import sceneOnImage from "../../../assets/smarthome/smartSection/SceneOn.jpg";
import sceneOffImage from "../../../assets/smarthome/smartSection/SceneOff.jpg";

export default function SmartSection(props) {
  const { textContent, language } = { ...props };
  const isMobile = useSelector((state) => state.screen.isMobile);
  const screenWidth = useSelector((state) => state.screen.screenWidth);

  const [isSceneActive, setIsSceneActive] = useState(true);

  const automationItem = (icon, subtitle, title) => {
    return (
      <div className="automation-item">
        <div className="automation-item-icon">
          <img src={icon} aria-hidden="true" className="automation-item-icon" />
        </div>
        <div>
          <h4 className="h4-bold h4-automation-item">{title}</h4>
          <h4 className="h4-automation-item">{subtitle}</h4>
        </div>
      </div>
    );
  };

  const automation1 = () => {
    return (
      <div className="automation">
        <h4 className="h3-automation-item">
          {
            textContent.smartSection.features.items.automation.operatorWhen[
              language
            ]
          }
          ...
        </h4>
        {automationItem(
          timeIcon,
          // textContent.smartSection.features.items.automation.automation1.when
          //   .title[language],
          textContent.smartSection.features.items.automation.automation1.when
            .subtitle[language],
        )}
        <h4 className="h3-automation-item">
          {
            textContent.smartSection.features.items.automation.operatorIf[
              language
            ]
          }
          ...
        </h4>
        {automationItem(
          motionIcon,
          // textContent.smartSection.features.items.automation.automation1.if
          //   .title[language],
          textContent.smartSection.features.items.automation.automation1.if
            .subtitle[language],
        )}
        <h4 className="h3-automation-item">
          {
            textContent.smartSection.features.items.automation.operatorOr[
              language
            ]
          }
          ...
        </h4>
        {automationItem(
          openIcon,
          // textContent.smartSection.features.items.automation.automation1.or
          //   .title[language],
          textContent.smartSection.features.items.automation.automation1.or
            .subtitle[language],
        )}
        <h4 className="h3-automation-item">
          {
            textContent.smartSection.features.items.automation.operatorThen[
              language
            ]
          }
          ...
        </h4>
        {automationItem(
          notificationIcon,
          // textContent.smartSection.features.items.automation.automation1.then
          //   .title[language],
          textContent.smartSection.features.items.automation.automation1.then
            .subtitle[language],
        )}
        <div className={isMobile ? "" : "container-empty-small"} />
        <img src={automation1Image} />
      </div>
    );
  };

  const automation2 = () => {
    return (
      <div className="automation">
        <h4 className="h3-automation-item">
          {
            textContent.smartSection.features.items.automation.operatorWhen[
              language
            ]
          }
          ...
        </h4>
        {automationItem(
          timeIcon,
          // textContent.smartSection.features.items.automation.automation2.when
          //   .title[language],
          textContent.smartSection.features.items.automation.automation2.when
            .subtitle[language],
        )}
        <h4 className="h3-automation-item">
          {
            textContent.smartSection.features.items.automation.operatorIf[
              language
            ]
          }
          ...
        </h4>
        {automationItem(
          motionIcon,
          // textContent.smartSection.features.items.automation.automation2.if
          //   .title[language],
          textContent.smartSection.features.items.automation.automation2.if
            .subtitle[language],
        )}
        <h4 className="h3-automation-item">
          {
            textContent.smartSection.features.items.automation.operatorAnd[
              language
            ]
          }
          ...
        </h4>
        {automationItem(
          illuminanceIcon,
          // textContent.smartSection.features.items.automation.automation2.or
          //   .title[language],
          textContent.smartSection.features.items.automation.automation2.or
            .subtitle[language],
        )}
        <h4 className="h3-automation-item">
          {
            textContent.smartSection.features.items.automation.operatorThen[
              language
            ]
          }
          ...
        </h4>
        {automationItem(
          lightBlack,
          // textContent.smartSection.features.items.automation.automation2.then
          //   .title[language],
          textContent.smartSection.features.items.automation.automation2.then
            .subtitle[language],
        )}
        <div className={isMobile ? "" : "container-empty-small"} />
        <img src={automation2Image} />
      </div>
    );
  };

  return (
    <section className="container">
      <div className={`container-small ${isMobile ? "smart-mobile" : ""}`}>
        <h1 className="title-gradient">
          {textContent.smartSection.title[language]}
        </h1>
        <h2>
          {textContent.smartSection.features.items.groups.title[language]}
        </h2>
        <p>
          {textContent.smartSection.features.items.groups.description[language]}
        </p>
        <h3 className="h3-bold">
          {textContent.smartSection.subtitle[language]}
        </h3>
      </div>
      {isMobile ? <div className="container-empty-small" /> : null}
      <div
        className={
          isMobile ? "smart-group-content-mobile" : "smart-group-content"
        }
      >
        {!isMobile ? <div /> : null}
        <div className="smart-group-visual">
          <img
            src={groupWithWallSwitch}
            alt="Salon avec interrupteur de groupe éclairage"
          />

          {/* OVERLAY */}
          <div className="smart-group-visual-content-overlay">
            <img
              src={groupIphoneMockup}
              alt="téléphone indiquant groupe d'éclairage"
            />
          </div>
        </div>
      </div>

      <div className="smart-automation-content">
        <div
          className={
            isMobile ? "container-empty-medium" : "container-empty-medium"
          }
        />
        <div className="container-small">
          <h2 className="h2-bold">
            {textContent.smartSection.features.items.automation.title[language]}
          </h2>
          <p>
            {
              textContent.smartSection.features.items.automation.description[
                language
              ]
            }
          </p>
        </div>
        <div
          className={
            isMobile
              ? "container-empty-extra-small"
              : "container-empty-extra-small"
          }
        />
        <div
          className={`grid-2 smart-automation ${screenWidth < 1000 ? "carousel" : ""}`}
        >
          {automation1()}
          {automation2()}
        </div>
      </div>

      <div className="smart-automation-content remove-gradient">
        <div
          className={
            isMobile ? "container-empty-medium" : "container-empty-medium"
          }
        />
        <div className={`container-small ${isMobile ? "smart-mobile" : ""}`}>
          <h2 className="h2-bold">
            {textContent.smartSection.features.items.scenes.title[language]}
          </h2>
          <p>
            {
              textContent.smartSection.features.items.scenes.description[
                language
              ]
            }
          </p>
        </div>
        <div
          className={
            isMobile
              ? "container-empty-extra-small"
              : "container-empty-extra-small"
          }
        />
        {!isMobile ? (
          <div className="smart-scene">
            <div className="scene1">
              <div className="media">
                <img src={sceneOffImage} />
              </div>
            </div>

            <div className="scene2">
              <div className="media">
                <img src={sceneOnImage} />
              </div>
            </div>
          </div>
        ) : (
          <div className="scene-mobile">
            <div className="scene-image-wrapper">
              <img
                src={sceneOffImage}
                className={`scene-img ${isSceneActive ? "hidden" : "visible"}`}
                alt=""
              />
              <img
                src={sceneOnImage}
                className={`scene-img ${isSceneActive ? "visible" : "hidden"}`}
                alt=""
              />
            </div>
            <button
              className={`toggle ${isSceneActive ? "on" : ""}`}
              onClick={() => setIsSceneActive(!isSceneActive)}
              role="switch"
              aria-checked={isSceneActive}
            >
              <span className="thumb" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
